import { EyeIcon } from "@heroicons/react/solid";
import { useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useGet from "../../hooks/read/useGet";
import useExcelUpload from "../../hooks/useExcelUpload";
import { InlineLoader } from "../../components/Loader";
import toast from "react-hot-toast";
import Pagination from "../../components/pagination";
import PrimaryLoader from "../../components/common/PrimaryLoader";
import DownloadAttendanceModal from "../../components/modal/DownloadAttendanceModal";
import { Switch } from "@mui/material";
import DateWiseAttendance from "./DateWiseAttendance";
import { getsingleDayWiseUsersAttendanceData } from "../../api/attendance";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";
import { Button } from "../../components/ui";
import LinkButton from "../../components/ui/LinkButton";

const Attendance = () => {
  const fileInputRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [datewiseAttendanceData, setDatewiseAttendanceData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [isUserwise, setIsUserwise] = useState(true);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  };
  const initialEmployeeState = {
    page_number: searchParams.get("page_number") || 0,
    limit: searchParams.get("limit") || 10,
    search_query: searchParams.get("search_query") || "",
  };
  const {
    list: employeeList,
    paramsObject,
    setGetListParams,
  } = useGet({
    url: "employeelist",
    initialData: initialEmployeeState,
    onSuccess: () => {
      scrollToTop();
      // toast.success('Employees Fetched Successfully')
    },
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });
  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  const handleDatewiseAttendanceData = (data) => {
    setDatewiseAttendanceData(data);
  };

  const handleSearch = async (e) => {
    const { name, value } = e.target;
    const updatedParams = {
      ...paramsObject,
      month_year: selectedDate,
      page_number: 0,
      [name]: value,
    };

    setGetListParams(updatedParams);
    setSearchParams(updatedParams);

    if (!isUserwise) {
      try {
        const response = await getsingleDayWiseUsersAttendanceData(
          updatedParams
        );
        setGetListParams({ ...updatedParams, data: response.data });
      } catch (error) {
        console.error("Error fetching date-wise attendance data:", error);
        toast.error("Failed to fetch date-wise attendance data.");
      }
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleToggleUser = () => {
    setIsUserwise(!isUserwise);
    let data = {
      ...paramsObject,
      page_number: 0,
      search_query: "",
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  return (
    <section className="pt-10 pb-10">
      <DownloadAttendanceModal
        show={showDownloadModal}
        setShow={setShowDownloadModal}
      />
      <>
      <RoundedContainer className={"mx-4"}>
        <div className="flex justify-between items-center pb-4 gap-4">
          <div className="w-[400px]">
            <input
              type="search"
              placeholder="Search By Name..."
              name="search_query"
              className="input"
              value={paramsObject.search_query}
              onChange={handleSearch}
            />
          </div>
          <div className="flex items-center gap-2">
            <p className="">Datewise</p>
            <Switch checked={isUserwise} onChange={handleToggleUser} />
            <p> Userwise</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-5">
          <LinkButton to="/attendance/upload" variant={"default"}>
            Upload Attendance
          </LinkButton>
          <Button
            onClick={() => setShowDownloadModal(true)}
            variant={"outline"}
          >
            Download Report
          </Button>
          <LinkButton to="/regularization-requests" variant="default">
            Regularization Requests
          </LinkButton>
        </div>
      </RoundedContainer>
      </>

      {isUserwise ? (
        <>
          {employeeList.isLoading ? (
            <div className=" flex items-center justify-center mt-10">
              {" "}
              <PrimaryLoader />
            </div>
          ) : (
            <>
              {employeeList?.data?.data?.length <= 0 ? (
                <div className="text-center">
                  <p className=" text-gray-700 text-3xl">No Users To Show</p>
                </div>
              ) : (
                <RoundedContainer className="mx-4">
                  <div className="max-w-full overflow-x-auto">
                    <Table className="table-auto w-full">
                      <TableHead>
                        <TableHeaderCell className="w-1/3 min-w-[160px]">
                          Name
                        </TableHeaderCell>
                        <TableHeaderCell className="w-1/3 min-w-[160px]">
                          Email
                        </TableHeaderCell>
                        {/* <TableHeaderCell className="w-1/6 min-w-[160px]">
                          User Type
                        </TableHeaderCell> */}
                        <TableHeaderCell className="w-1/3 min-w-[160px] text-center">
                          Attendance
                        </TableHeaderCell>
                      </TableHead>
                      <TableBody>
                        {employeeList?.data?.data?.map((data, index) => {
                          const {
                            employee_name,
                            email,
                            company_employee_id,
                          } = data;
                          return (
                            <TableRow key={index}>
                              <TableCell className="text-dark font-medium text-sm">
                                {employee_name}
                              </TableCell>
                              <TableCell className="text-dark font-medium text-sm">
                                {email}
                              </TableCell>
                              {/* <TableCell className="text-dark font-medium text-sm capitalize">
                                {type_of_employee}
                              </TableCell> */}
                              <TableCell className="text-dark font-medium text-sm">
                                <div className="flex items-center justify-center w-full">
                                  <LinkButton
                                    to={`/view-attendance/${company_employee_id}?employee_name=${employee_name}`}
                                  >
                                    <EyeIcon className="w-4 h-4 mr-1.5" />
                                    <span>View</span>
                                  </LinkButton>
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                </RoundedContainer>
              )}
              <RoundedContainer className={"mx-4"}>
                <Pagination
                  currentPage={+paramsObject.page_number}
                  lengthofItems={employeeList.data?.total_count}
                  limit={+paramsObject.limit}
                  onPageChange={handlePageClick}
                />
              </RoundedContainer>
            </>
          )}
        </>
      ) : (
        <DateWiseAttendance onDateChange={handleDateChange} />
      )}
    </section>
  );
};

export default Attendance;
